import { randomArr } from 'shared-base';

export const randomize = (parameters: Json) => {
  const output: Json = {};

  for (let parameter of Object.values(parameters)) {
    const { id, type } = parameter;
    if (id.startsWith('wack') || id === 'LOD') {
      continue;
    }

    switch (type) {
      case 'slider':
        output[id] = roundFixed(Math.random(), 2);
        break;
      case 'picker':
        const { options = [] } = parameter;
        const option = randomArr(options);
        output[id] = option;
        break;
      case 'toggle':
        output[id] = Math.random() > 0.5;
        break;
    }
  }

  return output;
};

export const roundFixed = (value: number, precision: number) => {
  const factor = 10 ** precision;
  return Math.round(value * factor) / factor;
};

export const getWackDelta = (valuesModel: Json, defaultWackParams: Json) => {
  const output: Json = {};

  Object.keys(defaultWackParams).forEach((key) => {
    const defaultValue = defaultWackParams[key];
    const value = valuesModel[key];

    if (value === undefined || value === defaultValue) {
      return;
    }

    output[key] = defaultValue;
  });

  return output;
};
